import { atom } from 'recoil';

export const dataFormInitialPalta = atom({
  key: 'dataFormInitialPalta',
  default: undefined,
});
